import * as _dayjs2 from "dayjs";
var _dayjs = "default" in _dayjs2 ? _dayjs2.default : _dayjs2;
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../../common/parsers/AbstractParserWithWordBoundary";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const dayjs_1 = __importDefault(_dayjs);
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const NOW_GROUP = 1;
  const DAY_GROUP_1 = 2;
  const TIME_GROUP_1 = 3;
  const TIME_GROUP_2 = 4;
  const DAY_GROUP_3 = 5;
  const TIME_GROUP_3 = 6;
  class ZHHantCasualDateParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern(context) {
      return new RegExp("(\u800C\u5BB6|\u7ACB(?:\u523B|\u5373)|\u5373\u523B)|" + "(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(\u65E9|\u671D|\u665A)|" + "(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668))|" + "(\u4ECA|\u660E|\u524D|\u5927\u524D|\u5F8C|\u5927\u5F8C|\u807D|\u6628|\u5C0B|\u7434)(?:\u65E5|\u5929)" + "(?:[\\s|,|\uFF0C]*)" + "(?:(\u4E0A(?:\u5348|\u665D)|\u671D(?:\u65E9)|\u65E9(?:\u4E0A)|\u4E0B(?:\u5348|\u665D)|\u664F(?:\u665D)|\u665A(?:\u4E0A)|\u591C(?:\u665A)?|\u4E2D(?:\u5348)|\u51CC(?:\u6668)))?", "i");
    }
    innerExtract(context, match) {
      const index = match.index;
      const result = context.createParsingResult(index, match[0]);
      const refMoment = dayjs_1.default(context.refDate);
      let startMoment = refMoment;
      if (match[NOW_GROUP]) {
        result.start.imply("hour", refMoment.hour());
        result.start.imply("minute", refMoment.minute());
        result.start.imply("second", refMoment.second());
        result.start.imply("millisecond", refMoment.millisecond());
      } else if (match[DAY_GROUP_1]) {
        const day1 = match[DAY_GROUP_1];
        const time1 = match[TIME_GROUP_1];
        if (day1 == "\u660E" || day1 == "\u807D") {
          if (refMoment.hour() > 1) {
            startMoment = startMoment.add(1, "day");
          }
        } else if (day1 == "\u6628" || day1 == "\u5C0B" || day1 == "\u7434") {
          startMoment = startMoment.add(-1, "day");
        } else if (day1 == "\u524D") {
          startMoment = startMoment.add(-2, "day");
        } else if (day1 == "\u5927\u524D") {
          startMoment = startMoment.add(-3, "day");
        } else if (day1 == "\u5F8C") {
          startMoment = startMoment.add(2, "day");
        } else if (day1 == "\u5927\u5F8C") {
          startMoment = startMoment.add(3, "day");
        }
        if (time1 == "\u65E9" || time1 == "\u671D") {
          result.start.imply("hour", 6);
        } else if (time1 == "\u665A") {
          result.start.imply("hour", 22);
          result.start.imply("meridiem", 1);
        }
      } else if (match[TIME_GROUP_2]) {
        const timeString2 = match[TIME_GROUP_2];
        const time2 = timeString2[0];
        if (time2 == "\u65E9" || time2 == "\u671D" || time2 == "\u4E0A") {
          result.start.imply("hour", 6);
        } else if (time2 == "\u4E0B" || time2 == "\u664F") {
          result.start.imply("hour", 15);
          result.start.imply("meridiem", 1);
        } else if (time2 == "\u4E2D") {
          result.start.imply("hour", 12);
          result.start.imply("meridiem", 1);
        } else if (time2 == "\u591C" || time2 == "\u665A") {
          result.start.imply("hour", 22);
          result.start.imply("meridiem", 1);
        } else if (time2 == "\u51CC") {
          result.start.imply("hour", 0);
        }
      } else if (match[DAY_GROUP_3]) {
        const day3 = match[DAY_GROUP_3];
        if (day3 == "\u660E" || day3 == "\u807D") {
          if (refMoment.hour() > 1) {
            startMoment = startMoment.add(1, "day");
          }
        } else if (day3 == "\u6628" || day3 == "\u5C0B" || day3 == "\u7434") {
          startMoment = startMoment.add(-1, "day");
        } else if (day3 == "\u524D") {
          startMoment = startMoment.add(-2, "day");
        } else if (day3 == "\u5927\u524D") {
          startMoment = startMoment.add(-3, "day");
        } else if (day3 == "\u5F8C") {
          startMoment = startMoment.add(2, "day");
        } else if (day3 == "\u5927\u5F8C") {
          startMoment = startMoment.add(3, "day");
        }
        const timeString3 = match[TIME_GROUP_3];
        if (timeString3) {
          const time3 = timeString3[0];
          if (time3 == "\u65E9" || time3 == "\u671D" || time3 == "\u4E0A") {
            result.start.imply("hour", 6);
          } else if (time3 == "\u4E0B" || time3 == "\u664F") {
            result.start.imply("hour", 15);
            result.start.imply("meridiem", 1);
          } else if (time3 == "\u4E2D") {
            result.start.imply("hour", 12);
            result.start.imply("meridiem", 1);
          } else if (time3 == "\u591C" || time3 == "\u665A") {
            result.start.imply("hour", 22);
            result.start.imply("meridiem", 1);
          } else if (time3 == "\u51CC") {
            result.start.imply("hour", 0);
          }
        }
      }
      result.start.assign("day", startMoment.date());
      result.start.assign("month", startMoment.month() + 1);
      result.start.assign("year", startMoment.year());
      return result;
    }
  }
  exports.default = ZHHantCasualDateParser;
  //# sourceMappingURL=ZHHantCasualDateParser.js.map
  return exports;
}